module.exports = __webpack_public_path__ + "img/uc1.bad0483a.png";